import InformationGrid from './InformationGrid';

export default InformationGrid;



// WEBPACK FOOTER //
// ./src/components/grids/InformationGrid/index.jsx